<template>
  <v-app id="inspire">
    <v-card-title>
      API Keys
      <v-spacer></v-spacer>
      <v-dialog width="unset" height="unset" v-model="dialogs.registerNew">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-5" color="secondary" v-bind="attrs" v-on="on">Register API Key</v-btn>
        </template>
        <v-card class="pa-2" background="white">
          <v-card-title> Create production license for new unit </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="my-3">
            <v-text-field v-model="newKey.issuedTo" label="Issued to" outlined> </v-text-field>
            <v-select v-model="newKey.type" :items="availableKeyTypes" label="API type" outlined></v-select>
            <v-select v-model="newKey.permissions" :items="availablePermissions" multiple label="Permissions" outlined></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialogs.registerNew = false">close</v-btn>
            <v-btn
              color="primary"
              @click="
                createApiKey(newKey);
                dialogs.registerNew = false;
              "
              >Create license</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :search="search" :items="apiKeys" :hide-default-footer="true" disable-pagination item-key="id" @click:row="refetchData()">
      <template v-slot:item.permissions="{ item }">
        <v-chip outlined label v-for="permission in item.permissions" :key="permission.resource" color="primary" class="ma-1">
          {{ permission.resource === '*' ? 'FULL ACCESS' : permission.resource }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item, attrs, on }">
        <!-- RESET PASSWORD FILE DOWNLOAD BUTTON -->
        <!-- DOWNLOAD LICENSE BUTTON -->
        <v-btn icon v-bind="attrs" v-on="on" @click="getSignedApiKey(item.id)">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <!-- DELETE PACKAGE BUTTON -->
        <v-btn icon v-bind="attrs" v-on="on" @click="deleteApiKey(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>
<style scoped></style>
<script>
  import { GET_ALL_API_KEYS_QUERY, CREATE_API_KEY, GET_SIGNED_API_KEY_QUERY, DELETE_API_KEY } from '../../graphql/licenseQueries.js';

  export default {
    created() {},
    components: {
      CConfirmationDialog: () => import('../common/CConfirmationDialog'),
    },
    data() {
      return {
        apiKeys: [],
        newKey: {
          type: '',
          issuedTo: '',
          permissions: [],
        },
        dialogs: {
          registerNew: false,
        },
        availableKeyTypes: ['EHUB'],
        availablePermissions: ['*', 'LIVE_DATA'],
        search: '',
        headers: [
          { text: 'API', value: 'type', sortable: true },
          { text: 'Issued to', value: 'issuedTo', sortable: false },
          { text: 'Permissions', value: 'permissions', sortable: false },
          {
            text: '',
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ],
      };
    },
    apollo: {
      $client: 'licenseClient',
      apiKeys: {
        query: GET_ALL_API_KEYS_QUERY,
        loadingKey: 'loading',
        update: (data) => data.getAllApiKeys,
      },
    },
    methods: {
      async createApiKey(newKey) {
        try {
          await this.$apollo.mutate({
            mutation: CREATE_API_KEY,
            variables: {
              type: newKey.type,
              issuedTo: newKey.issuedTo,
              permissions: newKey.permissions.map((p) => {
                return { resource: p };
              }),
            },
          });

          this.newKey = {
            type: '',
            issuedTo: '',
            permissions: [],
          };
        } catch (error) {
          alert('The service was not able to create a new API key.');
          console.error(error);
        }
        this.refetchData();
      },
      refetchData() {
        this.$apollo.queries.apiKeys.refetch();
      },
      async getSignedApiKey(apiKeyId) {
        try {
          const response = await this.$apollo.mutate({
            mutation: GET_SIGNED_API_KEY_QUERY,
            variables: {
              apiKeyId: apiKeyId,
            },
          });
          if (response.data.getSignedApiKey) {
            this.downloadFile(`${apiKeyId}.key`, response.data.getSignedApiKey);
          } else {
            alert('Could not download API key!');
          }
        } catch (error) {
          alert('Error downloading API key! ' + error.message);
          console.error(error);
        }
      },
      downloadFile(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      },
      async deleteApiKey(id) {
        if (await this.$refs.confirmationDialog.open('Are you sure you want to delete this API key?')) {
          try {
            await this.$apollo.mutate({
              mutation: DELETE_API_KEY,
              variables: {
                id: id,
              },
            });
            this.refetchData();
          } catch (error) {
            alert('Error deleting API key! ' + error.message);
          }
        }
      },
    },
  };
</script>
